import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { scheduleBid } from '../../../redux/calendar';
import { updateSearchCriteria, searchCustomers } from '../../../redux/searchBids';
import AvailableBids from './AvailableBids';

const colors = createSelector(
  (state) => state.settings.color,
  (state) => state.dropdowns,
  (colorMode, { jobStatuses, jobTypes, offices }) => {
    switch (colorMode) {
      case 'jobStatus':
        return jobStatuses;
      case 'office':
        return offices;
      default:
        return jobTypes;
    }
  }
);

const bids = createSelector(
  (state) => state.searchBids.bids,
  (state) => state.settings.color,
  colors,
  (bids, colorMode, colors) => {
    return bids.map((b) => {
      let color = null;
      switch (colorMode) {
        case 'office':
          const office = colors.find((office) => b.office && office.id === b.office.id);
          color = office ? office.color : null;
          break;
        case 'salesperson':
          const salesperson = b.salesperson;
          color = salesperson ? salesperson.calendarColor : null;
          break;
      }
      return { ...b, color };
    });
  }
)

const mapStateToProps = (state) => ({
  ...state.searchBids,
  activeCrew: state.calendar.activeCrew,
  bids: bids(state),
  detailEnabled: state.settings.detailEnabled,
  dropdowns: state.dropdowns,
  locationEnabled: state.settings.locationEnabled
});

const mapDispatchToProps = {
  onBidClick: scheduleBid,
  onCustomerSearch: searchCustomers,
  onFormUpdate: updateSearchCriteria
};

export default connect(mapStateToProps, mapDispatchToProps)(AvailableBids);
